import {type FunctionalComponent, h} from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';


export interface NumberOfResults {
    presentedResults: string | number
    totalResults: string | number
    labelProvider: labelProviderInterface
    term: string
    resultSummary: boolean
    isLoading: boolean
    hideLabelWithTerm: boolean
}

export const NumberOfResults: FunctionalComponent<NumberOfResults> = (props) => {

    const {presentedResults, totalResults, labelProvider, term, resultSummary, isLoading, hideLabelWithTerm: hideLabelWithTerm} = props;
    const of = labelProvider('load-more.of', 'of');
    const resultFor = labelProvider('results-for', 'results for');
    const qetQuery = ` ${resultFor} "${term}"`;

    return ( resultSummary ?
      <div class={{
        'search-tab__number-of-results': true,
        'search-tab__number-of-results--hidden': !(presentedResults as any > 0) || isLoading//eslint-disable-line @typescript-eslint/no-explicit-any
      }} >
        {`${presentedResults} ${of} ${totalResults}${hideLabelWithTerm ? ` ${labelProvider('results', 'results')}` : qetQuery}`}
      </div> : '');
};
